import React from "react";
import Context from "../../Context";
import { Dropdown } from "react-bootstrap";

export default class ToolbarA extends React.Component {
  static contextType = Context;

  componentDidMount() {
    this.context.actionsSet(this.renderButtons());
  }
  componentDidUpdate() {
    this.context.actionsSet(this.renderButtons());
  }

  renderScaleDropdown = () => {
    const scales = {
      25: "25%",
      50: "50%",
      75: "75%",
      100: "100%",
      125: "125%",
      150: "150%",
    };
    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          variant="light"
          id="dropdown-basic"
          title="Масштаб документа"
          aria-label="Масштаб документа"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {scales[this.props.currentScale]}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.entries(scales).map(([value, label]) => (
            <Dropdown.Item
              key={value}
              onMouseDown={(e) => {
                e.preventDefault();
                this.props.onToggleScale(value);
              }}
              className={` ${
                this.props.currentScale === value ? "bg-secondary" : ""
              }`}
            >
              {label}
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item
            onMouseDown={(e) => {
              e.preventDefault();
              this.props.onToggleScale("params");
            }}
          >
            Страница ...
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderButtons = () => {
    return (
      <div className="editor-actions">
        {this.props.pending ? (
          <div className="d-inline-block align-middle mr-10">
            <span className="spinner "></span>
          </div>
        ) : null}

        {this.props.autoSaveText ? (
          <span className="editor-autosave-status" role="status" aria-live="polite">
            {this.props.autoSaveText}
          </span>
        ) : null}

        {this.props.onDiscardAutoSave ? (
          <button
            type="button"
            title="Удалить временный черновик"
            aria-label="Удалить временный черновик"
            className="btn btn-light btn-icon mr-2"
            onMouseDown={(e) => {
              e.preventDefault();
              this.props.onDiscardAutoSave();
            }}
          >
            <span className="fa fa-trash"></span>
          </button>
        ) : null}

        <div className="btn-group mr-2">
          <button
            type="button"
            title="Назад: отменить последнее действие (Ctrl+Z)"
            aria-label="Назад: отменить последнее действие (Ctrl+Z)"
            className="btn btn-light btn-icon"
            disabled={!this.props.canUndo}
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            onClick={this.props.onUndo}
          >
            <span className="fa fa-undo"></span>
          </button>
          <button
            type="button"
            title="Вперёд: вернуть отменённое действие (Ctrl+Y)"
            aria-label="Вперёд: вернуть отменённое действие (Ctrl+Y)"
            className="btn btn-light btn-icon"
            disabled={!this.props.canRedo}
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            onClick={this.props.onRedo}
          >
            <span className="fa fa-repeat"></span>
          </button>
        </div>

        {this.props.onSave || this.props.onOpen || this.props.onNew ? (
          <div className="btn-group mr-2">
            {this.props.onSave ? (
              <button
                title="Сохранить документ"
                aria-label="Сохранить документ"
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onSave();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-save"></span>
              </button>
            ) : null}
            {this.props.onOpen ? (
              <button
                title="Открыть документ"
                aria-label="Открыть документ"
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onOpen();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-folder-open-o"></span>
              </button>
            ) : null}
            {this.props.onNew ? (
              <button
                title="Создать новый документ"
                aria-label="Создать новый документ"
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onNew();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-file-o"></span>
              </button>
            ) : null}
          </div>
        ) : null}

        <div className="d-inline-block ">
          <div className="btn-group">
            {this.props.onPreview ? (
              <button
                title="Предварительный просмотр"
                aria-label="Предварительный просмотр"
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onPreview();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-file-code-o"></span>
              </button>
            ) : null}
            {this.renderScaleDropdown()}
          </div>
        </div>

        {this.props.onClose ? (
          <button
            type="button"
            title="Закрыть редактор"
            aria-label="Закрыть редактор"
            onMouseDown={(e) => {
              e.preventDefault();
              this.props.onClose();
            }}
            className="btn editor-close-button"
          >
            <span className="fa fa-times"></span>
          </button>
        ) : null}
      </div>
    );
  };

  render() {
    return <></>;
  }
}
